import { styled as muiStyled, Stack, Table } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const StyledCard = muiStyled(Stack)({
  padding: '16px',
  borderRadius: '8px',
  borderColor: NEW_COLORS.PRIMARY[50],
  borderWidth: '1px',
  borderStyle: 'solid',
  backgroundColor: NEW_COLORS.GRAYSCALE[25],
  gap: '16px',
  overflow: 'auto',
});

const StyledTable = muiStyled(Table)({
  borderCollapse: 'separate',
  borderSpacing: '0 8px',
});

export { StyledCard, StyledTable };
